(function () {
  'use strict';

  function init() {
    var banner = document.getElementById('b12-consent-banner');
    if (!banner || !window.Shopify || !window.Shopify.customerPrivacy) return;

    var privacy = window.Shopify.customerPrivacy;

    // Already decided (this visit or a previous one) - stay hidden.
    if (privacy.currentVisitorConsent && privacy.currentVisitorConsent().marketing !== '') {
      return;
    }

    var dialog = banner.querySelector('.b12-consent-modal');
    var choices = document.getElementById('b12-consent-choices');
    var functionalInput = document.getElementById('b12-consent-functional');
    var analyticsInput = document.getElementById('b12-consent-analytics');
    var marketingInput = document.getElementById('b12-consent-marketing');
    var chooseBtn = banner.querySelector('[data-consent-action="choose"]');
    var functionalBtn = banner.querySelector('[data-consent-action="functional"]');
    var acceptBtn = banner.querySelector('[data-consent-action="accept"]');
    var saveBtn = banner.querySelector('[data-consent-action="save"]');

    // If the markup has drifted, do nothing rather than half-render a consent
    // gate. A banner that cannot record a choice is worse than no banner.
    if (
      !dialog ||
      !choices ||
      !functionalInput ||
      !analyticsInput ||
      !marketingInput ||
      !chooseBtn ||
      !functionalBtn ||
      !acceptBtn ||
      !saveBtn
    ) {
      return;
    }

    var lastFocused = null;

    // Tab is trapped inside the dialog while it is open. The banner declares
    // aria-modal="true", which tells assistive technology the rest of the page
    // is inert - so focus has to actually be in here, and stay here.
    function trapTab(event) {
      if (event.key !== 'Tab') return;

      var focusable = dialog.querySelectorAll(
        'button:not([hidden]):not([disabled]), input:not([disabled]), a[href]'
      );
      var visible = [];
      for (var i = 0; i < focusable.length; i++) {
        if (focusable[i].offsetParent !== null) visible.push(focusable[i]);
      }
      if (!visible.length) return;

      var first = visible[0];
      var last = visible[visible.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function show() {
      lastFocused = document.activeElement;
      banner.hidden = false;
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', trapTab, true);
      dialog.focus();
    }

    function hide() {
      document.removeEventListener('keydown', trapTab, true);
      banner.hidden = true;
      document.body.style.overflow = '';
      // Put focus back where the visitor left it, rather than dropping it to
      // the top of the document.
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    // Shopify's four categories. `preferences` is the functional category, so it
    // follows the functional choice - not the marketing one.
    function setConsent(functional, analytics, marketing) {
      privacy.setTrackingConsent(
        {
          preferences: functional,
          analytics: analytics,
          marketing: marketing,
          sale_of_data: marketing
        },
        hide
      );
      // setTrackingConsent's callback does not fire on every failure path, and a
      // banner left open holds the page scroll-locked. Close on the next frame
      // regardless; the consent call itself is unaffected.
      window.setTimeout(function () {
        if (!banner.hidden) hide();
      }, 1000);
    }

    chooseBtn.addEventListener('click', function () {
      choices.hidden = false;
      chooseBtn.setAttribute('aria-expanded', 'true');
      chooseBtn.hidden = true;
      functionalBtn.hidden = true;
      acceptBtn.hidden = true;
      saveBtn.hidden = false;
      // The button that had focus is now hidden, so move focus onto the first
      // control the visitor is being asked about rather than losing it to body.
      functionalInput.focus();
    });

    functionalBtn.addEventListener('click', function () {
      setConsent(true, false, false);
    });

    acceptBtn.addEventListener('click', function () {
      setConsent(true, true, true);
    });

    saveBtn.addEventListener('click', function () {
      setConsent(!!functionalInput.checked, !!analyticsInput.checked, !!marketingInput.checked);
    });

    show();
  }

  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error) return;
        init();
      }
    );
  }
})();
